module.exports = __webpack_public_path__ + "img/bg_mid_autumn_pay_dialog.9e562e19.png";